/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  var fakeStorage = {
    get: function () {},
    key: function () {},
    getItem: function () {},
    setItem: function () {},
    removeItem: function () {},
    clear: function () {},
    length: 15,
  };

  /**
   * Коллекция для кэша поисковых подсказок
   */
  app.SearchTipsCache = app.Collection.extend({
    model: app.Model,

    localStorage: (function() {
      try {
        return new Backbone.LocalStorage('search-tips-cache');
      } catch (e) {
        return fakeStorage;
      }
    })(),

    comparator: function (element) {
      return element.get('time');
    }
  });

})();

}.call(window));